import styled from 'styled-components'

import Text from 'components/reusable/text'
import { colors } from 'helpers/colors'

export const H1 = styled(props => <Text {...props} tag="h1" />)`
  font-size: 48px;
  font-weight: 500;
  line-height: 110%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 42px;
  }
  @media (max-width: 768px) {
    font-size: 32px;
  }
`

export const H2 = styled(props => <Text {...props} tag="h2" />)`
  font-size: 40px;
  font-weight: 500;
  line-height: 110%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 34px;
  }
  @media (max-width: 768px) {
    font-size: 28px;
  }
`

export const H3 = styled(props => <Text {...props} tag="h3" />)`
  font-size: 32px;
  font-weight: 500;
  line-height: 110%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 28px;
  }
  @media (max-width: 768px) {
    font-size: 24px;
  }
`

export const H4 = styled(props => <Text {...props} tag="h4" />)`
  font-size: 24px;
  font-weight: 500;
  line-height: 110%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 20px;
  }
  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const H5 = styled(props => <Text {...props} tag="h5" />)`
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 18px;
  }
`

export const H6 = styled(props => <Text {...props} tag="h6" />)`
  font-size: 18px;
  font-weight: 500;
  line-height: 120%;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
  }
`

export const BodyMain = styled(Text)`
  font-size: 16px;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 14px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const BodySecondary = styled(Text)`
  font-size: 14px;
  color: ${({ color }) => color || colors.gray[700]};

  @media (max-width: 1440px) {
    font-size: 12px;
  }
  @media (max-width: 768px) {
    font-size: 12px;
  }
`
